/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Progress_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shot change detection progress" |
*
* @param {Scene_Change_Detection_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_progress_aria_label = /** @type {((inputs?: Scene_Change_Detection_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de la detection de changement de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortschritt der Schussänderungserkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progresso nel rilevamento del cambio di tiro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("прогресс обнаружения смены кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso en la detección de cambios de toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("投篮变化检测进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更検出の進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन पहचान प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso da detecção de mudança de tiro")
	return /** @type {LocalizedString} */ ("Shot change detection progress")
});